export default __webpack_public_path__ + "static/media/vscode.f8ce41c1.svg";